import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { Utils } from 'src/app/common/utils';
import { VproService } from 'src/app/service/vpro/vpro.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
@Component({
  selector: 'app-superadmin-medicine-search',
  templateUrl: './superadmin-medicine-search.component.html',
  styleUrls: ['./superadmin-medicine-search.component.css']
})
export class SuperadminMedicineSearchComponent implements OnInit {
  @ViewChild('showeditmedsubcateModal', { static: true } as any) showeditmedsubcateModal: TemplateRef<any>;
  medicine: any;
  create_med_cate_form: UntypedFormGroup;
  cate: any;
  selected: any;
  subcate: any;
  today = Utils.today;
  med_type_ = Utils.MED_TYPE;
  createmedicineform: UntypedFormGroup;
  med_id: any;
  med_name: any;
  med_strength: any;
  med_cate: any;
  med_type: any;
  med_sub_cate: any;
  edited_at: Date;
  med_cate_id: any;
  med_sub_cate_id: any;
  med_sub_cates: any;
  text = '';
  medicineAuo: any;






  // myControl = new FormControl('');
  // options: string[] = ['One', 'Two', 'Three'];
  // filteredOptions: Observable<string[]>;



  constructor(
    private modal: NgbModal,
    private spinner: NgxSpinnerService,
    private service: VproService,
    private _formBuilder: UntypedFormBuilder,
  ) {
    this.createmedicineform = this._formBuilder.group({
      // med_category: [''],
      // med_subcategory: [''],
      med_cate_id: [''],
      med_sub_cate_id: [''],
      med_name: [''],
      med_type: [''],
      med_strength: [''],
      med_status: [''],
      created_at: [''],
      created_by: [''],

    })
    this.create_med_cate_form = this._formBuilder.group({

      med_cate: [null],
      med_sub_cate: [null],
      medicine: [''],

    })
  }

  ngOnInit(): void {
    this.getMedicinecategory();

  }

  getMedicinecategory() {
    this.spinner.show();
    this.service
      .getMedicinecategory()
      .subscribe(
        (res) => {
          this.spinner.hide();
          this.cate = res;
          console.log("CATEGORY", this.cate);
        },
        (error) => {
          this.spinner.hide();
          Utils.showToast("error", "Something went wrong. Please try again.");
        }
      );
  }

  retriveSubcategory(e) {
    this.selected = e.target.value
    let subcatid = parseInt(this.selected);
    console.log(this.selected);

    this.service
      .retriveMedsubcate({ subcat: subcatid })
      .subscribe((result) => {

        this.subcate = result;
      })
    console.log("--------------------", this.subcate)

  }
  getMedicinerecords() {

    this.spinner.show();
    let data = { ...this.create_med_cate_form.value };
    if (data.med_cate) {
      data.med_cate = parseInt(data.med_cate);
    }
    if (data.med_sub_cate) {
      data.med_sub_cate = parseInt(data.med_sub_cate);
    }
    if (data.med_cate === null) {
      delete data.med_cate;
    }
    if (data.med_sub_cate === null) {
      delete data.med_sub_cate;
    }
    if (data.medicine === '') {
      delete data.medicine;
    }

    console.log("data", data)
    this.service
      .fetchMedicineRecords(data)
      .subscribe(
        (res) => {
          this.spinner.hide();
          this.medicine = res;
          console.log("CATEGORY", this.medicine);
        },
        (error) => {
          this.spinner.hide();
          Utils.showToast("error", "Something went wrong. Please try again.");
        }
      );


  }


  showeditmedsubcate(data) {
    console.log("dtaaaaaaaaaaaaaaaaaaaaa", data)


    this.med_id = data.med_id;
    this.med_name = data.med_name;
    this.med_cate = data.med_cate;
    this.med_strength = data.med_strength;
    this.med_sub_cate = data.med_sub_cate;
    this.med_type = data.med_type;
    this.med_cate_id = parseInt(data.med_cate_id)
    this.med_sub_cate_id = parseInt(data.med_sub_cate_id);


    this.createmedicineform.patchValue({


      med_id: this.med_id,
      med_name: this.med_name,
      med_cate: this.med_cate,
      med_strength: this.med_strength,
      med_sub_cate: this.med_sub_cate,
      med_type: this.med_type,
      med_cate_id: this.med_cate_id,
      med_sub_cate_id: this.med_sub_cate_id,
    });

    this.modal.open(this.showeditmedsubcateModal, { size: 'lg', centered: true, backdrop: 'static' });

  }


  onAccStatusChange = async (data) => {
    delete data.med_cate;
    delete data.med_sub_cate;
    let med_id = data.med_id;
    let med_name = data.med_name;
    let med_cate_id = data.med_cate_id;
    let med_strength = data.med_strength;
    let med_sub_cate_id = data.med_sub_cate_id;
    let med_type = data.med_type;
    data.edited_at = this.today;
    data.edited_by = "Admin";
    data.med_status = false;

    this.spinner.show();
    this.service
      .editMedicineRecor(med_id, data)
      .subscribe((res) => {
        this.spinner.hide();
        Utils.showToast('success', "Medicine Deleted successfuly");
        this.create_med_cate_form.reset();
        this.refresh();
      },
        (error) => {
          this.spinner.hide();
          let message;
          if (error && error.error && error.error.message && error.error.message.message) {
            message = error.error.message.message;
          }
          else message = "Something went wrong. Couldn't update profile."
          Utils.showToast('error', message);
        }
      );
  }

  medicinesFet(e) {
    let medi = e.target.value
    console.log("============", medi)
    this.text += e.target.value
    console.log("this.text", this.text)
    let medicine = medi;
    console.log("medicine", medicine)
    let val = { medicine: medicine }
    if (val.medicine === '') {
      delete val.medicine;
    }
    this.service
      .fetchMedicineRecords(val)
      .subscribe(
        (res) => {
          this.spinner.hide();
          this.medicineAuo = res;
          console.log("CATEGORY", this.medicineAuo);
        },
        (error) => {
          this.spinner.hide();
          Utils.showToast("error", "Something went wrong. Please try again.");
        }
      );
  }

  refresh(): void {
    window.location.reload();
  }


  // save the medicine
  createmedicine(mid) {

    let timestmp = new Date();



    let data = { ...this.createmedicineform.value };
    data.med_cate_id = parseInt(data.med_cate_id);
    data.med_sub_cate_id = parseInt(data.med_sub_cate_id);
    data.med_status = true;
    data.edited_at = this.today;
    data.edited_by = "Admin";
    delete data.med_cate;
    delete data.med_sub_cate;
    delete data.created_at;
    delete data.created_by;
    let med_id = mid;
    data.med_id = mid;
    console.log("medid", med_id);
    // let med_name = data.med_name;
    // let med_cate_id = data.med_cate_id;
    // let med_strength = data.med_strength;
    // let med_sub_cate_id = data.med_sub_cate_id;
    // let med_type = data.med_type;
    // data.edited_at = this.today;
    // data.edited_by = "Admin";
    // data.med_status = false;

    // this.spinner.show();
    // this.service
    //   .editMedicineRecor(med_id, data)
    //   .subscribe((result) => {
    //     Utils.showToast("success", "Medicine updated successfully");
    //     //this.prescriptionForm.reset();
    //   });


    this.spinner.show();
    this.service
      .editMedicineRecor(med_id, data)
      .subscribe((res) => {
        this.spinner.hide();
        Utils.showToast('success', "Medicine Update successfuly");
        this.create_med_cate_form.reset();

      },
        (error) => {
          this.spinner.hide();
          let message;
          if (error && error.error && error.error.message && error.error.message.message) {
            message = error.error.message.message;
          }
          else message = "Something went wrong. Couldn't update profile."
          Utils.showToast('error', message);
        }
      );


    //let medicine = [{ data }];
    console.log("Medicine", data);

  }
}